var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21289 0C3.79092 0 0.212891 3.57834 0.212891 8C0.212891 12.422 3.79123 16 8.21289 16C12.6349 16 16.2129 12.4217 16.2129 8C16.2129 3.57803 12.6345 0 8.21289 0ZM8.21289 14.75C4.48186 14.75 1.46289 11.7308 1.46289 8C1.46289 4.26897 4.48211 1.25 8.21289 1.25C11.9439 1.25 14.9629 4.26922 14.9629 8C14.9629 11.731 11.9437 14.75 8.21289 14.75Z",
    fill: "#E6A708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21289 4.0274C7.8677 4.0274 7.58789 4.30721 7.58789 4.6524V8.67717C7.58789 9.02236 7.8677 9.30217 8.21289 9.30217C8.55808 9.30217 8.83789 9.02236 8.83789 8.67717V4.6524C8.83789 4.30721 8.55808 4.0274 8.21289 4.0274Z",
    fill: "#E6A708"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21289 11.755C8.67888 11.755 9.05664 11.3772 9.05664 10.9112C9.05664 10.4452 8.67888 10.0675 8.21289 10.0675C7.7469 10.0675 7.36914 10.4452 7.36914 10.9112C7.36914 11.3772 7.7469 11.755 8.21289 11.755Z",
    fill: "#E6A708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e7c857f5740619cd6ffdbe3eb2611fcc.svg";
export { ForwardRef as ReactComponent };